"use strict";
/*
* Created on Wed Feb 05 2020
*/

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Holds data for RPM Report
 * NOTE: detail data are loaded in real time, so this class just holds basic info
 *
 * @author PKr
 * @author Tomáš Leity
 */


var ReplenishmentPromoManagementReport =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ReplenishmentPromoManagementReport, _DomainObject_1$Domai);

  /**
   * @param id
   * @param promotionIds
   * @param categoryIds
   */
  function ReplenishmentPromoManagementReport(id, promotionIds, categoryIds) {
    var _this;

    _classCallCheck(this, ReplenishmentPromoManagementReport);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReplenishmentPromoManagementReport).call(this));
    _this.id = id;
    _this.promotionIds = promotionIds;
    _this.categoryIds = categoryIds;
    return _this;
  }
  /**
   * Converter from data-dictionary representation
   */


  _createClass(ReplenishmentPromoManagementReport, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new ReplenishmentPromoManagementReport(mat.id, mat.promotionIds, mat.categoryIds);
    }
  }]);

  return ReplenishmentPromoManagementReport;
}(DomainObject_1.DomainObject);

exports.ReplenishmentPromoManagementReport = ReplenishmentPromoManagementReport;

ReplenishmentPromoManagementReport.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ReplenishmentPromoManagementReport.name);
  return {
    id: builder.id('id'),
    promotionIds: builder.listOf(builder.id('promotionIds')),
    categoryIds: builder.opt(builder.listOf(builder.id('categoryIds')))
  };
}();